// extracted by mini-css-extract-plugin
export default {"BlogItem":"BlogItem_28dep","mainImage":"mainImage_3-n4k","portrait":"portrait_B6LL7","landscape":"landscape_8rJTn"};